import {
  IconArrowLeft,
  IconArrowRight,
  Button,
  TextOverflow,
  GreyGrey60,
  Primary12SemiBold,
  Primary12Regular,
  Box,
  Flex
} from '@sequencehq/core-components'
import { ReactNode } from 'react'

const linkStyling = (showLink: boolean) => ({
  transition: 'opacity 0.15s ease-in-out',
  color: GreyGrey60,
  ...Primary12SemiBold,
  alignItems: 'center',
  padding: '8px',
  gap: '8px',
  opacity: showLink ? 1 : 0,
  cursor: showLink ? 'pointer' : 'default',
  pointerEvents: showLink ? ('all' as const) : ('none' as const)
})

export const LeftLink = ({
  showLink,
  onClick,
  label,
  description
}: {
  showLink: boolean
  onClick: () => void
  label: string
  description?: ReactNode
}) => {
  return (
    <Flex {...linkStyling(showLink)} onClick={onClick}>
      <Button
        variant="ghost"
        icon={<IconArrowLeft color={GreyGrey60} />}
        aria-label="left-arrow"
      />
      <Flex flexDirection="column" alignItems="flex-start" gap="4px">
        <TextOverflow>{label}</TextOverflow>
        {description && (
          <Box
            {...Primary12Regular}
            color={GreyGrey60}
            whiteSpace="nowrap"
            textOverflow="ellipsis"
            overflow="hidden"
            maxWidth="250px"
          >
            {description}
          </Box>
        )}
      </Flex>
    </Flex>
  )
}

export const RightLink = ({
  showLink,
  onClick,
  label,
  description
}: {
  showLink: boolean
  onClick: () => void
  label: string
  description?: ReactNode
}) => {
  return (
    <Flex
      {...linkStyling(showLink)}
      justifyContent="flex-end"
      onClick={onClick}
    >
      <Flex flexDirection="column" alignItems="flex-end" gap="4px">
        <TextOverflow>{label}</TextOverflow>
        {description && (
          <Box
            {...Primary12Regular}
            color={GreyGrey60}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          >
            {description}
          </Box>
        )}
      </Flex>
      <Button
        variant="ghost"
        icon={<IconArrowRight color={GreyGrey60} />}
        aria-label="right-arrow"
      />
    </Flex>
  )
}
